import styled from 'styled-components'
import { FONT_WEIGHT, SPACE } from 'Theme'

export const OL = styled('ol')`
  counter-reset: index;
  list-style-type: none;
  padding-left: ${SPACE.PX_32};
  li {
    display: block;
    &:before {
      font-weight: ${FONT_WEIGHT.MEDIUM};
      margin-left: -${SPACE.PX_32};
      content: counters(index, '.', decimal) '. ';
      counter-increment: index;
    }
  }
`

export const LowerLetterOL = styled('ol')`
  counter-reset: alphabeticList;
  li {
    display: block;
    &:before {
      font-weight: ${FONT_WEIGHT.NORMAL};
      margin-left: -${SPACE.PX_32};
      content: '(' counter(alphabeticList, lower-alpha) ') ';
      counter-increment: alphabeticList;
    }
  }
`

export const UpperLetterOL = styled('ol')`
  counter-reset: alphabeticList;
  li {
    display: block;
    &:before {
      font-weight: ${FONT_WEIGHT.NORMAL};
      margin-left: -${SPACE.PX_32};
      content: '(' counter(alphabeticList, upper-alpha) ') ';
      counter-increment: alphabeticList;
    }
  }
`
